export var UsageType;
(function (UsageType) {
    UsageType["USAGE_TYPE_BACKUP_STORAGE"] = "Backup storage";
    UsageType["USAGE_TYPE_BACKUP_DATA_TRANSFER"] = "Data transfer";
    UsageType["USAGE_TYPE_BACKUP_THREAT_DETECTION"] = "Threat detection";
    UsageType["USAGE_TYPE_BACKUP_CLASSIFICATION"] = "Classification";
    UsageType["USAGE_TYPE_COLD_TIER_STORAGE"] = "Cold tier storage";
    UsageType["USAGE_TYPE_COLD_TIER_MANAGED_OBJECTS"] = "Cold tier managed objects";
    UsageType["USAGE_TYPE_DSG_STORAGE"] = "DSG_STORAGE";
    UsageType["USAGE_TYPE_DSG_DATA_TRANSFER"] = "DSG_DATA_TRANSFER";
    UsageType["USAGE_TYPE_DSG_API_REQUESTS"] = "DSG_API_REQUESTS";
    UsageType["USAGE_TYPE_DSG_AUTOCLASS_FEE"] = "DSG_AUTOCLASS_FEE";
    UsageType["USAGE_TYPE_DSG_DATA_RETRIEVAL"] = "DSG_DATA_RETRIEVAL";
    UsageType["USAGE_TYPE_DSG_INVENTORY_REPORTS"] = "DSG_INVENTORY_REPORTS";
})(UsageType || (UsageType = {}));
